import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const bare = pathname === "/auth" || pathname.startsWith("/payment");
  return (
    <>
      {!bare && <Navbar />}
      {children}
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <div className="camo-bg" />
      <div className="grain" />
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <Chrome>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/marketplace" element={<Marketplace />} />
                <Route path="/listing/:id" element={<ListingDetail />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </Chrome>
          </SmoothScroll>
          <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { borderRadius: 0, border: "1px solid #5A2A24", background: "#2C0D12", color: "#EFE4D2", fontFamily: "JetBrains Mono, monospace" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
